"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var solidGaugeOptions_1 = __importDefault(require("./solidGaugeOptions"));
var dialGaugeOptions_1 = __importDefault(require("./dialGaugeOptions"));
function default_1(gauge, chartTooltip, initialRun) {
    var options;
    var useDial = gauge.props.useDial;
    options = useDial
        ? dialGaugeOptions_1.default(gauge, chartTooltip, initialRun)
        : solidGaugeOptions_1.default(gauge, chartTooltip, initialRun);
    return options;
}
exports.default = default_1;
//# sourceMappingURL=gaugeOptions.js.map